import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fs-14 fa-question-circle text-warning" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "boxTitle"
}
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "title text-cyan" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "form-group col-sm-6" }
const _hoisted_10 = ["readonly"]
const _hoisted_11 = { class: "title text-cyan" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "form-group col-sm-6" }
const _hoisted_14 = ["readonly"]
const _hoisted_15 = { class: "form-group col-sm-6" }
const _hoisted_16 = ["readonly"]
const _hoisted_17 = { class: "col-sm-6 text-center" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_21 = { class: "quantoCostato text-danger" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "quantoCostato text-danger" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "quantoCostato text-danger" }
const _hoisted_26 = {
  key: 2,
  class: "text-center"
}
const _hoisted_27 = { class: "boxTitle" }
const _hoisted_28 = { class: "wrapContainer" }
const _hoisted_29 = { class: "wrapSpacer" }
const _hoisted_30 = { class: "square" }
const _hoisted_31 = { class: "midTitle" }
const _hoisted_32 = { class: "quantoCostato text-success" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "wrapSpacer" }
const _hoisted_35 = { class: "square" }
const _hoisted_36 = { class: "midTitle" }
const _hoisted_37 = { class: "quantoCostato text-success" }
const _hoisted_38 = { class: "title" }
const _hoisted_39 = { class: "wrapSpacer" }
const _hoisted_40 = { class: "square" }
const _hoisted_41 = { class: "midTitle" }
const _hoisted_42 = { class: "quantoCostato text-success" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = { class: "wrapSpacer" }
const _hoisted_45 = { class: "square" }
const _hoisted_46 = { class: "midTitle" }
const _hoisted_47 = { class: "quantoCostato text-success" }
const _hoisted_48 = { class: "title" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "text-center mt-3" }
const _hoisted_53 = { class: "title" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { key: 2 }
const _hoisted_59 = { class: "form-group mt-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "title mb-2" }
const _hoisted_63 = {
  key: 0,
  class: "text-center mt-3"
}
const _hoisted_64 = {
  key: 1,
  class: "text-center mt-3"
}
const _hoisted_65 = { class: "midTitle" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_67 = { class: "form-group text-center mt-4" }
const _hoisted_68 = { class: "midTitle" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("😎🤞🎉😁 ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 😎🤞🎉😁")
const _hoisted_71 = {
  key: 0,
  class: "text-center"
}
const _hoisted_72 = { class: "boxTitle" }
const _hoisted_73 = { class: "wrapContainer" }
const _hoisted_74 = { class: "wrapSpacer" }
const _hoisted_75 = { class: "square" }
const _hoisted_76 = { class: "midTitle" }
const _hoisted_77 = { class: "quantoCostato text-success" }
const _hoisted_78 = { class: "title" }
const _hoisted_79 = { class: "wrapSpacer" }
const _hoisted_80 = { class: "square" }
const _hoisted_81 = { class: "midTitle" }
const _hoisted_82 = { class: "quantoCostato text-success" }
const _hoisted_83 = { class: "title" }
const _hoisted_84 = { class: "wrapSpacer" }
const _hoisted_85 = { class: "square" }
const _hoisted_86 = { class: "midTitle" }
const _hoisted_87 = { class: "quantoCostato text-success" }
const _hoisted_88 = { class: "title" }
const _hoisted_89 = { class: "wrapSpacer" }
const _hoisted_90 = { class: "square" }
const _hoisted_91 = { class: "midTitle" }
const _hoisted_92 = { class: "quantoCostato text-success" }
const _hoisted_93 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_comments_container = _resolveComponent("comments-container")!
  const _component_toggler = _resolveComponent("toggler")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-link float-right",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.infoModal && _ctx.infoModal(...args)))
        }, _hoisted_3),
        (!_ctx.xSuccessMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Facciamo due conti?",
                text: "Facciamo due conti?"
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.xSuccessMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Quando hai iniziato a fumare?",
                    text: "Quando hai iniziato a fumare?"
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Anno",
                        text: "Anno"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.calcoliFumo.annoInizio) = $event)),
                      readonly: _ctx.xSuccessMode
                    }, null, 8, _hoisted_10), [
                      [_vModelText, _ctx.user.calcoliFumo.annoInizio]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.xSuccessMode)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 0,
                        localizedKey: "Quanto fumavi",
                        text: "Quanto fumavi"
                      }))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Quanto fumi?",
                        text: "Quanto fumi?"
                      }))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Sigarette al giorno",
                        text: "Sigarette al giorno"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.calcoliFumo.quanteSigaretteAlGiorno) = $event)),
                      readonly: _ctx.xSuccessMode
                    }, null, 8, _hoisted_14), [
                      [_vModelText, _ctx.user.calcoliFumo.quanteSigaretteAlGiorno]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Prezzo pacchetto",
                        text: "Prezzo pacchetto"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.calcoliFumo.prezzoPacchettoSigarette) = $event)),
                      readonly: _ctx.xSuccessMode
                    }, null, 8, _hoisted_16), [
                      [_vModelText, _ctx.user.calcoliFumo.prezzoPacchettoSigarette]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Quanto ti è costato fumare",
                    text: "Quanto ti è costato fumare"
                  }),
                  _hoisted_19,
                  (!_ctx.user.calcoliFumo.hoSmesso)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 0,
                        localizedKey: " fino ad oggi",
                        text: " fino ad oggi"
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_20
                ]),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.currency(_ctx.quantoCostato)) + " €", 1),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Alla settimana:",
                    text: "Alla settimana:"
                  })
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$filters.currency(_ctx.allaSettimana)) + " €", 1),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Al mese:",
                    text: "Al mese:"
                  })
                ]),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$filters.currency(_ctx.alMese)) + " €", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.xSuccessMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Sai qual è l'impatto della tua scelta?",
                  text: "Sai qual è l'impatto della tua scelta?"
                })
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Quanto hai risparmiato:",
                        text: "Quanto hai risparmiato:"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$filters.currency(_ctx.risparmiato)) + " €", 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Sulla base di quanto spendevi",
                      text: "Sulla base di quanto spendevi"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "CO2 risparmiata",
                        text: "CO2 risparmiata"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.co2) + " g", 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Ogni sigaretta emette 14g di CO2",
                      text: "Ogni sigaretta emette 14g di CO2"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Alberi salvati:",
                        text: "Alberi salvati:"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$filters.currency(_ctx.alberi)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Viene abbattuto un albero ogni 300 sigarette",
                      text: "Viene abbattuto un albero ogni 300 sigarette"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Speranza di vita guadagnata:",
                        text: "Speranza di vita guadagnata:"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$filters.tempofromminuti(_ctx.speranzaVita as number)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Ogni sigaretta ti toglieva 11 minuti",
                      text: "Ogni sigaretta ti toglieva 11 minuti"
                    })
                  ])
                ])
              ])
            ]))
          : (_ctx.acquistiInAttesa.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Hai scelto di acquistare la prenotazione tramite bonifico.",
                          text: "Hai scelto di acquistare la prenotazione tramite bonifico."
                        }),
                        _hoisted_54,
                        _createVNode(_component_localized_text, {
                          localizedKey: "Abbiamo inviato su <u>{{email}}</u> un'email con le istruzioni per il pagamento.",
                          text: "Abbiamo inviato su <u>{{email}}</u> un'email con le istruzioni per il pagamento.",
                          object: { email: _ctx.user.contactData.email}
                        }, null, 8, ["object"]),
                        _hoisted_55,
                        _createVNode(_component_localized_text, {
                          localizedKey: "Se non l'hai ricevuta puoi chiedere un nuovo invio cliccando qui",
                          text: "Se non l'hai ricevuta puoi chiedere un nuovo invio cliccando qui"
                        })
                      ]),
                      (_ctx.timerBonifico > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Attendi {{timerBonifico}} secondi prima di poter chiedere una nuova email",
                              text: "Attendi {{timerBonifico}} secondi prima di poter chiedere una nuova email",
                              object: { timerBonifico: _ctx.timerBonifico }
                            }, null, 8, ["object"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.showEmailBonifico)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-warning mt-2",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEmailBonifico = true)),
                            disabled: _ctx.timerBonifico > 0
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Invia nuovamente istruzioni per il bonifico",
                              text: "Invia nuovamente istruzioni per il bonifico"
                            })
                          ], 8, _hoisted_57))
                        : _createCommentVNode("", true),
                      (_ctx.showEmailBonifico)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("label", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Invieremo le istruzioni a questo indirizzo email",
                                  text: "Invieremo le istruzioni a questo indirizzo email"
                                })
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "email",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tempMail) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.tempMail]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.inviaIstruzioniBonifico && _ctx.inviaIstruzioniBonifico(...args)))
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Conferma",
                                  text: "Conferma"
                                })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_60,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success mt-2",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.annullaPagamentoBonifico && _ctx.annullaPagamentoBonifico(...args)))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Clicca qui se preferisci pagare con carta di credito",
                          text: "Clicca qui se preferisci pagare con carta di credito"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Qui puoi allegare la prova di avvenuto bonifico o porre domande all'amministrazione",
                        text: "Qui puoi allegare la prova di avvenuto bonifico o porre domande all'amministrazione"
                      })
                    ]),
                    _createVNode(_component_comments_container, {
                      comments: _ctx.pagamentoBonifico.comments,
                      onAdd: _ctx.addCommento
                    }, null, 8, ["comments", "onAdd"])
                  ])
                ])
              ], 64))
            : (!_ctx.hasPrenotato)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (_ctx.tickets.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-big",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.buyModal && _ctx.buyModal(...args)))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "CLICCA QUI PER PRENOTARE!",
                            text: "CLICCA QUI PER PRENOTARE!"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tickets.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Hai un voucher prenotazione disponibile",
                            text: "Hai un voucher prenotazione disponibile"
                          })
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-big mt-2",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.prenotaModal && _ctx.prenotaModal(...args)))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Continua con la prenotazione",
                            text: "Continua con la prenotazione"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.trattamentoFatto)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, [
                            (_ctx.user.calcoliFumo.hoSmesso)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_69
                                ], 64))
                              : _createCommentVNode("", true),
                            _createVNode(_component_localized_text, {
                              localizedKey: "Clicca qui perchè hai ufficialmente smesso di fumare",
                              text: "Clicca qui perchè hai ufficialmente smesso di fumare"
                            }),
                            (_ctx.user.calcoliFumo.hoSmesso)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_70
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_toggler, {
                              modelValue: _ctx.user.calcoliFumo.hoSmesso,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.calcoliFumo.hoSmesso) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        (_ctx.user.calcoliFumo.hoSmesso)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Sai qual è l'impatto della tua scelta?",
                                  text: "Sai qual è l'impatto della tua scelta?"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Quanto hai risparmiato:",
                                        text: "Quanto hai risparmiato:"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$filters.currency(_ctx.risparmiato)) + " €", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_78, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Sulla base di quanto spendevi",
                                      text: "Sulla base di quanto spendevi"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("div", _hoisted_81, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "CO2 risparmiata",
                                        text: "CO2 risparmiata"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.co2) + " g", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_83, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Ogni sigaretta emette 14g di CO2",
                                      text: "Ogni sigaretta emette 14g di CO2"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Alberi salvati:",
                                        text: "Alberi salvati:"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$filters.currency(_ctx.alberi)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_88, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Viene abbattuto un albero Ogni 300 sigarette",
                                      text: "Viene abbattuto un albero Ogni 300 sigarette"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", _hoisted_91, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Speranza di vita guadagnata:",
                                        text: "Speranza di vita guadagnata:"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$filters.tempofromminuti(_ctx.speranzaVita as number)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_93, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Ogni sigaretta ti toglieva 11 minuti",
                                      text: "Ogni sigaretta ti toglieva 11 minuti"
                                    })
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
      ]))
    : _createCommentVNode("", true)
}